import React, { DOMElement, useState, useEffect } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import {
  Button,
  Checkbox,
  Box,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
  Typography,
  FormHelperText,
} from "@mui/material";
import TextInput from "./commons/TextInput";
import Commons from "oc-commons/Commons";
import CheckboxInput from "./commons/CheckboxInput";
import uiActions from "../uiActions";
import Parts from "./sidebar/overview/Parts";
import Dekore from "./sidebar/overview/Dekore";
import Helper from "../../model/Helper";

export default class Stammdaten extends React.Component {
    getSidebarParent() {
        return null;
    }
    
    renderTitle() {
        return I18N("Zusammenfassung");
    }

    downloadClicked(ev) {
        uiActions.pdf();
    }

    putIntoBasket(ev) {
        uiActions.basket();
    }

    saveClicked(ev) {
        uiActions.save();
    }

    saveReqeust() {
        if (APP.arrangement.kunde.isValid) {
            APP.save(
                () => {
                    APP.uiHandler.ui.hideModal();
                    APP.uiHandler.dialog({
                        title: APP.arrangement.kunde.DirektBeiHaendler ? I18N("Bestellung abgeschickt title") : I18N("Anfrage abgeschickt title"),
                        text: APP.arrangement.kunde.DirektBeiHaendler ? I18N("Bestellung abgeschickt text") : I18N("Anfrage abgeschickt text"),
                        buttons: [
                            {
                                style: "primary",
                                label: I18N("Schließen")
                            },
                        ],
                    });
                }, 
                () => {
                    console.error("saving failed")
                }, 
                true
            );

            // if (checked) {
            // APP.save(APP.arrangement.kunde, values, "Bei Hersteller bestellt");
            // } else {
            // APP.save(APP.arrangement.kunde, values, "Bei Händler bestellt");
            // }
        }
    }

    favouritesClickes(ev) {}

    onChange(closure) {
        return (v) => {
            closure(v);
            this.forceUpdate();
        };
    }

    
    renderBody() {
        //TODO: SETTINGS!
        // return (<button className="button primary big-button"
        // onClick={() => this.saveClicked()} href="#">{I18N("Speichern")}</button>)
        
        const radioStyle = {
            fontSize: "1.6rem", 
            paddingTop: "6px", 
            textAlign: "left"
        }
        
        const haendler = APP.haendler;
        const isHaendler = APP.settings.haendler != null;
        const kunde = APP.arrangement.kunde;
        kunde.isHaendler = isHaendler;
        const admin = APP.settings.userRole == "admin";
        const adminAndInsipration = admin && APP.configuration.Inspiration;

        // small workaround for development
        const kundeValidate = kunde.validate();

        const allowedToSafe = (admin) || 
            (kundeValidate && Commons.isEmpty(APP.configuration.ordered_at)) ||
            APP.configuration.Inspiration;
            
        return (
            <div id="stammdatenDialog" className="appear">
                <div className="spacer-before">
                    <dl>
                        <dt>{I18N("Maße:")}</dt>
                        <dd>
                            {APP.arrangement.schraenke
                                .map(
                                    (schrank) =>
                                        Helper.formatToRulerUnit(schrank.size.x) +
                                        " x " +
                                        Helper.formatToRulerUnit(schrank.size.y) +
                                        " x " +
                                        Helper.formatToRulerUnit(schrank.size.z)
                                )
                                .reduce((akku, curr, index) => (
                                    <React.Fragment key={index}>
                                        {" "}
                                        {akku} <br /> {curr}{" "}
                                    </React.Fragment>
                                ))}
                        </dd>
                        <dt>{I18N("Elemente:")}</dt>
                        <dd>
                            {APP.arrangement.schraenke
                                .map((schrank) => schrank.elements.length)
                                .reduce((akku, curr, index) => (
                                    <React.Fragment key={index}>
                                        {" "}
                                        {akku} <br /> {curr}{" "}
                                    </React.Fragment>
                                ))}
                            <br />
                        </dd>
                        <Parts arrangement={APP.arrangement} lookUpKey={"Einbauten"} label={"Ausstattung:"} />
                        <Parts arrangement={APP.arrangement} lookUpKey={"Türen"} label={"Türen:"} />
                        <Dekore arrangement={APP.arrangement} />
                        <Parts arrangement={APP.arrangement} lookUpKey={"Griffe"} label={"Griffe:"} />
                    </dl>
                </div>
                {adminAndInsipration ? (
                    <div>{I18N("Eine Inspiration hat keine Stammdaten")}</div>
                ) : (
                    <>
                    <TextInput
                        id="outlined-vorname"
                        label={I18N("Stammdaten_Vorname")}
                        name="vorname"
                        value={kunde.Vorname || ""}
                        onChange={this.onChange((v) => (kunde.Vorname = v))}
                        required
                        sx={{
                            width: "100%",
                        }}
                    />
                    <TextInput
                        id="outlined-nachname"
                        label={I18N("Stammdaten_Nachname")}
                        name="nachname"
                        value={kunde.Nachname || ""}
                        onChange={this.onChange((v) => (kunde.Nachname = v))}
                        required
                        sx={{
                            width: "100%",
                        }}
                    />
                    <TextInput
                        id="outlined-telefon"
                        label={I18N("Stammdaten_Telefon")}
                        name="telefon"
                        value={kunde.Telefonnummer || ""}
                        onChange={this.onChange((v) => (kunde.Telefonnummer = v))}
                        required
                        sx={{
                            width: "100%",
                        }}
                    />
                    <TextInput
                        id="outlined-email"
                        label={I18N("Stammdaten_Email")}
                        name="email"
                        autoComplete="email"
                        value={kunde.EMailAdresse || ""}
                        required
                        onChange={this.onChange((v) => (kunde.EMailAdresse = v))}
                        required
                        sx={{
                            width: "100%",
                        }}
                    />
                    </>
                )}
                <TextInput
                    id={"Sonderwuensche"}
                    placeholder={I18N("Notiz zum Schrank")}
                    label={I18N("Extras")}
                    type={"textarea"}
                    rows={"3"}
                    value={APP.arrangement.bemerkungen}
                    onChange={this.onChange((v) => (APP.arrangement.bemerkungen = v))}
                />
                
                <FormLabel component="legend">{I18N("fronten_liefertyp")}</FormLabel>
                <RadioGroup
                    name="liefertyp"
                    onChange={this.onChange((v) => (kunde.Liefertyp = v))}
                >
                    <FormControlLabel
                        value="fronten_liefertyp_aufmaß"
                        control={<Radio />}
                        label={<Typography style={radioStyle}>{I18N("fronten_liefertyp_aufmaß")}</Typography>}
                    />
                    <FormControlLabel
                        value="fronten_liefertyp_abholung"
                        control={<Radio />}
                        label={<Typography style={radioStyle}>{I18N("fronten_liefertyp_abholung")}</Typography>}
                    />
                    <FormControlLabel
                        value="fronten_liefertyp_lieferung"
                        control={<Radio />}
                        label={<Typography style={radioStyle}>{I18N("fronten_liefertyp_lieferung")}</Typography>}
                    />
                    <FormControlLabel
                        value="fronten_liefertyp_lieferungmontiert"
                        control={<Radio />}
                        label={<Typography style={radioStyle}>{I18N("fronten_liefertyp_lieferungmontiert")}</Typography>}
                    />
                    <FormControlLabel
                        value="fronten_liefertyp_lieferungmontiertmontage"
                        control={<Radio />}
                        label={<Typography style={radioStyle}>{I18N("fronten_liefertyp_lieferungmontiertmontage")}</Typography>}
                    />
                </RadioGroup>

                {isHaendler && (
                    <Box
                    sx={{
                        width: "100%",
                        marginBottom: "1rem",
                    }}
                    >
                    <hr></hr>
                    <Typography style={radioStyle}>
                        {I18N(
                        "fronten_haendlerbereich_formular",
                        haendler?.loginname?.toUpperCase()
                        )}
                    </Typography>
                    <br></br>
                    <br></br>
                    <TextInput
                        id="outlined-kundennr"
                        label={I18N("Stammdaten_Kundennummer")}
                        name="kundennummer"
                        value={kunde.Kundennummer}
                        onChange={this.onChange((v) => (kunde.Kundennummer = v))}
                        sx={{
                        width: "100%",
                        marginBottom: "1rem",
                        }}
                    />
                    <CheckboxInput
                        id={"direktbeihaendler"}
                        sx={{ width: "100%", marginBottom: "1rem" }}
                        label={<Typography style={{...radioStyle, paddingTop: 0 }}>{I18N("direkt Bestellen")}</Typography>}
                        value={kunde.DirektBeiHaendler}
                        onChange={this.onChange((v) => (kunde.DirektBeiHaendler = v))}
                    />
                    
                    {kunde.HerstellerLiefertyp && (
                        <Box
                        sx={{
                            width: "100%",
                            marginBottom: "1rem",
                            textAlign: "left"
                        }}
                        >
                            <FormLabel component="legend">
                                <Typography style={radioStyle}>{I18N("fronten_hersteller_liefertyp")}</Typography>
                            </FormLabel>
                            <RadioGroup
                                name="hersteller_liefertyp"
                                onChange={this.onChange((v) => (kunde.HerstellerLiefertyp = v))}
                            >
                                <FormControlLabel
                                value="fronten_lieferung_hersteller_lieferung"
                                control={<Radio />}
                                label={I18N("fronten_lieferung_hersteller_lieferung")}
                                />
                                <FormControlLabel
                                value="fronten_lieferung_hersteller_abholung"
                                control={<Radio />}
                                label={I18N("fronten_lieferung_hersteller_abholung")}
                                />
                            </RadioGroup>
                        </Box>
                    )}
                    <hr></hr>
                    </Box>
                )}
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <CheckboxInput
                        id={"datenschutz"}
                        label={<Typography style={{...radioStyle, paddingTop: 0 }}>{I18N("fronten_datenschutz")}</Typography>}
                        value={kunde.dsChecked}
                        onChange={this.onChange((v) => (kunde.dsChecked = v))}
                    />
                </Box>
                
                <div className="price-wrapper">
                    <h2> {I18N("Preis")} </h2>
                    <div className="price-inner">
                        <div className="price">{Helper.formatMoney(APP.arrangement.preis?.gesamtPreis)}</div>
                        {APP.settings.userLoggedIn && APP.arrangement.preis?.rabatt > 0 && (
                            <div className="rabatt">
                                - {Helper.formatMoney(APP.arrangement.preis?.rabatt)} [{I18N("Haendlerrabatt")}] ={" "}
                                {Helper.formatMoney(APP.arrangement.preis?.gesamtPreis - APP.arrangement.preis?.rabatt)}
                            </div>
                        )}
                        <div className="shipment">{I18N("Lieferung DE")}</div>
                    </div>
                </div>

                <div className="button-wrapper text-right">
                    {kundeValidate.length != 0 && (
                        <p class="error-message">
                            {I18N("Feldpflicht")} <br/>
                            {kundeValidate.map((errorField, index) => (
                                <React.Fragment key={index}>
                                    {" - "}
                                    {errorField} <br />
                                </React.Fragment>
                            ))}
                        </p>
                    )}
                    {!Commons.isEmpty(APP.configuration.ordered_at) && <p>{I18N("Der Schrank wurde bereits bestellt")}</p>}

                    {APP.settings.customerPDF && (
                        <button 
                            className="button primary big-button"
                            onClick={() => this.downloadClicked()} 
                            href="#"
                        >
                            {I18N("PDF")}
                        </button>
                    )}

                    <button
                        className="button primary big-button"
                        disabled={kundeValidate.length != 0}
                        onClick={() => this.saveReqeust()}
                        href="#"
                    >
                        {kunde.DirektBeiHaendler ? I18N("OK") : I18N("Anfragen")}
                    </button>

                    {APP.settings.enableBasket && (
                        <button
                            className="button primary big-button"
                            disabled={valid.length != 0 || !Commons.isEmpty(APP.configuration.ordered_at)}
                            onClick={() => this.putIntoBasket()} href="#">
                            {I18N("basket")}
                        </button>
                    )}
                </div>
            </div>
        );
    }

    render() {
        return (
            <aside id="scroll-sidebar" className="sidebar stammdaten">
                
                    <div className="sidebar-header row">
                        <div className="left col-1"></div>
                        <div className="middle col-12">
                            <div className="sidebar-title">{this.renderTitle()}</div>
                        </div>
                    </div>
                    <div className="sidebar-body">{this.renderBody()}</div>
                <div className={" " + (Commons.isEmpty(this.getSidebarParent()) ? "only-mobile " : "")}>
                    <button className="primary finished-button" onClick={() => APP.uiHandler.sidebar(this.getSidebarParent())} href="#">
                        {I18N("Fertig")}
                    </button>
                </div>
            </aside>
        );
    }
}
